import * as actions from "./apportionmentKey.actions";
import * as api from "./apportionmentKey.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY, } from "./apportionmentKey.constants";
import * as hooks from "./apportionmentKey.hooks";
import * as promises from "./apportionmentKey.promises";
import { ApportionmentKeyReducer, } from "./apportionmentKey.reducer";
import { saga } from "./apportionmentKey.saga";
import * as selectors from "./apportionmentKey.selectors";
export * from "./apportionmentKey.types";
export var REDUCER_KEY_APPORTIONMENT_KEYS = REDUCER_KEY;
export var apportionmentKeyModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: ApportionmentKeyReducer,
    saga: saga,
    selectors: selectors,
    utils: {},
};
